// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Json from "../../primitives/Json.res.js";

function encodeHttpContext(jwt) {
  let headers = {};
  headers["Authorization"] = Json.encodeString("Bearer " + jwt);
  let context = {};
  context["headers"] = Json.encodeDict(headers);
  return Json.encodeDict(context);
}

export {
  encodeHttpContext,
}
/* No side effect */
